import { Link } from "react-router-dom";
import { JOYSPOT_QUIZ_URL } from "@/lib/constants";

const btnPrimary =
  "inline-flex items-center justify-center gap-2 bg-[#FF5A4F] text-white rounded-[10px] px-6 py-3 text-sm font-medium hover:bg-[#e8463c] transition-colors";

export function HomeFinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="relative overflow-hidden text-center"
      style={{ background: "linear-gradient(180deg, #F9F8F7 0%, #FAFAF8 100%)" }}
    >
      <div
        aria-hidden
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] opacity-[0.03]"
        style={{ background: "radial-gradient(circle, #FF5A4F 0%, transparent 60%)" }}
      />
      <div className="max-w-4xl mx-auto px-6 md:px-10 pt-12 md:pt-16 pb-[32px] md:pb-[43px] relative z-[1]">
        <h2 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight text-[#1C1917] reveal">
          Ready to find your JOYspot™?
        </h2>
        <div className="mt-10 reveal">
          <a href={JOYSPOT_QUIZ_URL} data-testid="final-cta-button" className={btnPrimary}>
            Find Your JOYspot™
          </a>
        </div>
        <p className="mt-5 text-sm text-[#57534E] reveal">Take the free 3-minute quiz.</p>
      </div>
    </section>
  );
}
